import React from "react";
import { useQuery } from "@tanstack/react-query";
import { getMarqueeData } from "../../services/HomeManageService";
import "./HomePage.css";

const getLatestTitle = (apiItems) => {
  if (!Array.isArray(apiItems) || apiItems.length === 0) {
    return "";
  }

  return apiItems[0]?.title || "";
};

const MarqueeStrip = ({ speed = 25, pauseOnHover = true }) => {
  const { data: marqueeItems } = useQuery({
    queryKey: ["marquee"],
    queryFn: getMarqueeData,
    staleTime: 5 * 60 * 1000,
  });

  const latestTitle = getLatestTitle(marqueeItems);

  if (!latestTitle) {
    return null;
  }

  return (
    <div className="marquee-strip__wrapper">
      <div
        className={`marquee-strip__track${pauseOnHover ? " marquee-strip__track--pauseable" : ""}`}
        style={{ animationDuration: `${speed}s` }}
      >
        <span className="marquee-strip__item">
          {latestTitle}
          <span className="marquee-strip__sep"></span>
        </span>
      </div>
    </div>
  );
};

export default MarqueeStrip;
